import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, GroupDto, IdentifierType } from '../../../models';
import { IGroupService, IModelWidgetService, ILoggerService } from '../../../services';
import { guidEmpty, errorTextColor, warningTextColor } from '../../../common/constants';
import { IRootScope } from 'IRootScope';
import { groupAdded, groupSelected, groupTreeChanged, isEditMode } from '../../../common/events';
import { Helper } from '../../../common/helpers';

class ElementTemplateController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    isEditMode: boolean;
    group: any;
    allGroups: GroupDto[];
    private _selectedGroupGuid;

    static $inject = [
        '$scope',
        '$rootScope',
        '$q',
        '$translate',
        'groupService',
        'modelWidgetService',
        'loggerService'
    ];

    constructor(private _$scope: angular.IScope,
        private _$rootScope: IRootScope,
        private _$q: angular.IQService,
        private _$translate: angular.translate.ITranslateService,
        private _groupService: IGroupService,
        private _modelWidgetService: IModelWidgetService,
        private _loggerService: ILoggerService) {
    }

    $onInit() {
        this.isEditMode = this._$rootScope.isEditMode;
        this._groupService.getAll().then(group => this.allGroups = group);

        this._$scope.$on(isEditMode, (event, data) => {
            this.isEditMode = data;
        });
    }

    isSelected() {
        return this._modelWidgetService.selectedGroupGuid() === this.group.guid;
    }

    addChild(data) {
        if (this.group) {
            const itemId = data.itemId;
            switch (itemId) {
                case 'group':
                    this.createGroup('', []);
                    break;
                case 'redundancyGroup':
                    this.createGroup('Redundancy', [{ name: 'Result', type: IdentifierType.CalculatedValue }]);
                    break;
                default:
                    this.updateExisiting(itemId);
                    break;
            }
        }
    }

    private updateExisiting(itemId) {
        const movedItemGuid = itemId.replace('group', '');
        if (movedItemGuid !== this.group.guid) {
            this._groupService
                .isChildOrSubChild(this.group.guid, movedItemGuid)
                .then(result => {
                    if (!result) {
                        return this._groupService.getByGuid(movedItemGuid);
                    } else {
                        this._loggerService.logWarning('Cannot add a parent to one of its children.');
                        return this._$q.reject();
                    }
                })
                .then((foundGroup: any) => {
                    if (foundGroup && foundGroup.group &&
                        !_.some(this.allGroups, g => g.group.parentGUID === this.group.guid &&
                            foundGroup.group.name.toLowerCase() === g.group.name.toLowerCase())) {
                        foundGroup.group.parentGUID = this.group.guid;
                        return this._groupService.updateGroup(foundGroup.group);
                    }
                    return this._$q.reject('Name must be unique in ancestor.');
                })
                .then(groupsDto => {
                    this._loggerService.logSuccess('Successfully updated group.');
                    this._$rootScope.$broadcast(groupTreeChanged);
                })
                .catch(reason => this._loggerService.logError(`Failed to update group : ${reason.message ? reason.message : reason}`));
        } else {
            this._loggerService.logWarning('Cannot add a group on itself');
        }
    }

    private createGroup(groupType: string, identifiers?: { name: string, type: IdentifierType }[]) {
        const group = {
            parentGUID: this.group.guid,
            name: '',
            guid: Helper.getGuid(),
            type: groupType,
            identifierCollection: identifiers ? identifiers.map(i => {
                return {
                    name: this._$translate.instant(i.name),
                    type: i.type
                };
            }) : []
        };
        if (!this.group.children) {
            this.group.children = [];
        }
        this._groupService
            .addGroup(group)
            .then(result => {
                this._loggerService.logSuccess('Successfully created group.');
                this._modelWidgetService.selectedGroupGuid(group.guid);
                this._$rootScope.$broadcast(groupAdded, group);
            })
            .catch(reason => this._loggerService.logError('Failed to create group.'));
    }

    select($event: angular.IAngularEvent) {
        if (this.group.guid !== guidEmpty) {
            this._$rootScope.$broadcast(groupSelected, this.group, true);
            this._modelWidgetService.selectedGroupGuid(this.group.guid);
            $event.stopPropagation();
        }
    }

    showModal(selector: string, $event: angular.IAngularEvent): void {
        $(selector).modal('toggle');
    }

    getStyle() {
        let style: any = {};
        const hasError = !this.group.name || (this.group.name !== 'root' && !this.group.type);
        const hasWarning = (!this.group.children || this.group.children.length === 0) && this.group.identifierCollection.length === 0;
        if (hasError) {
            style = { 'color': errorTextColor };
        } else if (hasWarning) {
            style = { 'color': warningTextColor };
        }
        return style;
    }
}

export const wtElementTemplate: ComponentDefinition = {
    componentId: 'wtElementTemplate',
    controller: ElementTemplateController,
    template: require('./elementTemplate.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
